import { render } from "./MerchandisesViewsDetail.vue?vue&type=template&id=3f50e584&scoped=true"
import script from "./MerchandisesViewsDetail.vue?vue&type=script&lang=js"
export * from "./MerchandisesViewsDetail.vue?vue&type=script&lang=js"

import "./MerchandisesViewsDetail.vue?vue&type=style&index=0&id=3f50e584&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f50e584"]])

export default __exports__